export default __webpack_public_path__ + "static/media/think.118bdfa1.png";